import { specialCh } from "../variables";

export const renameFile = (file) => {
    if (!file || !file.name) return null;

    const specialChars = specialCh;
    const sanitizedFileName = file.name.replace(new RegExp(`[${specialChars}]`, "g"), "_");

    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 15);

    const lastDotIndex = sanitizedFileName.lastIndexOf(".");
    const nameWithoutExt = lastDotIndex !== -1 ? sanitizedFileName.slice(0, lastDotIndex) : sanitizedFileName;
    const extension = lastDotIndex !== -1 ? sanitizedFileName.slice(lastDotIndex) : "";

    const uniqueFileName = `${nameWithoutExt}_${timestamp}${extension}`;

    return new File([file], uniqueFileName, { type: file.type });
};
